<div class="container">
  <merri-loading-spinner
    *ngIf="loading"
    class="spinner"
    diameter="75"
    [loading]="loading"
  ></merri-loading-spinner>
  <div
    class="workspace"
    *ngIf="!loading"
  >
    <app-visionboard-categories class="categories"></app-visionboard-categories>
    <mat-drawer-container hasBackdrop="false">
      <mat-drawer
        class="item-selection-drawer"
        #itemDrawer
        mode="over"
        disableClose
        [autoFocus]="false"
      >
        <app-visionboard-item-selection-panel
          class="item-selection-panel"
          *ngIf="!hideItems"
          forceVisionboardItemAddRemoveButton="none"
          source="Freeform View Search Results"
        ></app-visionboard-item-selection-panel>
      </mat-drawer>

      <mat-drawer-content class="drawer-content">
        <ng-content select="[workspace-controls]"></ng-content>
        <div class="panels">
          <app-visionboard-workspace-freeform-venue-items
            class="venue-items"
            *ngIf="showVenueItems"
          ></app-visionboard-workspace-freeform-venue-items>
          <app-visionboard-workspace-freeform-selected-items class="selected-items"></app-visionboard-workspace-freeform-selected-items>
        </div>
      </mat-drawer-content>
    </mat-drawer-container>
  </div>
</div>
